var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.565 7.77875C13.9023 7.44149 13.9023 6.89467 13.565 6.5574C13.2278 6.22012 12.6809 6.22012 12.3437 6.5574L8.30239 10.5987L6.66737 8.90088C6.33653 8.55732 5.7898 8.54696 5.44622 8.87782C5.10265 9.20868 5.09233 9.75536 5.42318 10.099L7.66864 12.4308C7.82946 12.5978 8.05073 12.6932 8.28261 12.6953C8.51441 12.6975 8.73749 12.6064 8.90141 12.4424L13.565 7.77875Z",
    fill: "#4A9A93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 0C4.2533 0 0 4.2533 0 9.5C0 14.7467 4.2533 19 9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.2533 14.7467 0 9.5 0ZM1.72727 9.5C1.72727 5.20724 5.20724 1.72727 9.5 1.72727C13.7928 1.72727 17.2727 5.20724 17.2727 9.5C17.2727 13.7928 13.7928 17.2727 9.5 17.2727C5.20724 17.2727 1.72727 13.7928 1.72727 9.5Z",
    fill: "#4A9A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.6c3721b4aca6f04204bd07fc227c5802.svg";
export { ForwardRef as ReactComponent };